import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FavoriteCardTypeEnum, UserFavoriteCardData } from '../../../user-favorite-data.model';
import { Currency } from '../../../../../model/landingModel';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { FavoriteSocialService } from '../../../favorite-social.service';

@Component({
  selector: 'accomodations-card',
  template: `
    <div class="accommodations {{cardType}}">
      <div class="relative">
        <div class="eva-3-offer-card">
          <div class="offer-card-image">
            <fav-image [srcSet]="favImage"></fav-image>
          </div>

          <span *ngIf="data.outstanding_driver" class="favorite-card-driver eva-3-driver offer-card-main-driver">
            <span class="driver-text">
              <fav-image [src]="driverImage" [cssClass]="'driver-image'"> </fav-image>
              {{ data.outstanding_driver.text }}
            </span>
          </span>

          <div class="-eva-3-mt-md -eva-3-ml-lg -eva-3-mr-lg">
            <h4 class="eva-3-h4 -eva-3-ellipsis">{{ data.main_text }}</h4>
          </div>

          <div class="favorite-card-content-spacing rating-section">
            <div *ngIf="data.overall_rating" class="eva-3-rating -good -sm">
              <span class="rating-text">{{ data.overall_rating }}</span>
            </div>

            <div *ngIf="data.overall_rating_text">
              <span class="overall-rating-text">{{ data.overall_rating_text }}</span>
            </div>

            <div *ngIf="data.stars" class="stars">
              <i *ngFor="let star of stars" class="eva-3-icon-star"
                [ngClass]="{'-eva-3-icon-xsm': cardType !== FavoriteCardTypeEnum.REDUCED}"></i>
            </div>

            <div class="-eva-3-pt-xsm">
              <favorite-card-drivers [data]="data" [tooltipsPosition]="position === 0 ? 'right' : 'left' "></favorite-card-drivers>
            </div>
          </div>

          <div class="auxiliary-text -eva-3-ml-lg -eva-3-mr-lg eva-3-caption -eva-3-tc-gray-1">
            {{ data.auxiliary_text }}
          </div>

          <div class="favorite-card-pricebox-spacing"
            *ngIf="cardType !== 'REDUCED'">
            <favorite-card-pricebox
              [data]="data"
              [moduleId]="moduleId"
              [moduleIndex]="moduleIndex"
              [currency]="currency"
              [locale]="locale"
              [isWhiteLabel]="isWhiteLabel"
              [showAlertBtn]="showAlertBtn"
              [uniqueId]="uniqueId"
            ></favorite-card-pricebox>
          </div>
        </div>
        <!-- Header is on the top of the card -->
        <div class="header-positioning">
          <div class="header-spacing">
            <card-header
              [showDeleteBtn]="showDeleteBtn"
              (onDeleteFavoriteClick)="onDeleteFavoriteClick.emit()"
              [externalId]="data.external_id"
              [product]="data.product"
              [flow]="flow"
            >
              <div></div>
            </card-header>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['../common-styles.scss', './accomodations-card.component.scss'],
})
export class AccomodationsCardComponent implements OnInit {
  @Input() data: UserFavoriteCardData;
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() isWhiteLabel: boolean;
  @Input() showAlertBtn: boolean;
  @Input() flow: string;
  @Input() showDeleteBtn: boolean;
  @Input() cardType: FavoriteCardTypeEnum;
  @Input() position: number;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDeleteFavoriteClick = new EventEmitter();

  favImage: string | undefined;
  driverImage: string | undefined;
  stars: any[] = [];
  FavoriteCardTypeEnum = FavoriteCardTypeEnum;

  constructor(public mediaPictureService: MediaPictureService, private favoriteSocialService: FavoriteSocialService) {}

  ngOnInit(): void {
    this.favImage = this.favoriteSocialService.getFavImgSrcUrl(this.data.picture_link, this.cardType);

    if (this.data.outstanding_driver) {
      this.driverImage = this.mediaPictureService.getMediaUrl(this.data.outstanding_driver.icon_src);
    }

    if (this.data.stars) {
      this.stars = new Array(Number(this.data.stars));
    }
  }
}
